<template>
  <div class="ucrs-property__featuresWrapper">
    <ul class="ucrs-property__features">
      <li
        v-for="(feat, i) in features"
        :key="i"
        v-dompurify-html="feat"
        class="ucrs-property__feature"
      ></li>
    </ul>
    <LazyPropertyActions
      :property="property"
      class="hidden lg:flex"
      @hidden-add="$emit('hidden-add')"
      @hidden-remove="$emit('hidden-remove')"
      @favorite-add="$emit('favorite-add')"
      @favorite-remove="$emit('favorite-remove')"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

const LazyPropertyActions = defineAsyncComponent(() =>
  import('~/components/PropertyActions.vue')
)

export default {
  components: {
    LazyPropertyActions,
  },
  props: {
    features: {
      type: Array,
      default: null,
    },
    property: {
      type: Object,
      default: null,
    },
  },
}
</script>
